export function sortInsurences (insurences) {
  const convenios = []

  insurences.map(item => {
    convenios.push({ 'nome': item.nome,
                      'id': item.sghs[0].codigoConvenio,
                      'sgh': item.sghs[0].codigoSgh })
  });
  return convenios.sort((a, b) => (a.nome > b.nome) ? 1 : -1)
}
